import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from "./index";

// let lang = localStorage.languageCode || ''

var i18nConfig = {
  locale: 'ja-jp',
  messages: messages
};
Vue.use(VueI18n);
var i18n = new VueI18n(i18nConfig);
export default i18n;